// ActivityAdd.js
import { useNavigate } from "react-router-dom";
import React, { useState, useRef } from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert } from 'react-bootstrap';
import { createSubject } from '../../api/api'

const SubjectAdd = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [name, setName] = useState(null);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();


  const handleChange = (event) => {
    const { value } = event.target;
    setName(value);
  };

  const handleSubmit = async (event) => {
    setIsButtonDisabled(true);

    try {
      event.preventDefault();
      const form = formRef.current;
      setIsFormValidated(true);

      if (form.checkValidity() === false) {
        event.stopPropagation();
        setShowErrorAlert(true);

      } else {
        // Append file input to formData (if a file is selected)
        const response = await createSubject(name);

        setShowSuccessAlert(true);

        navigate('/dashboard/subject/edit/' + response.uuid);

        // Remove validation styles
      }
      form.classList.remove('was-validated');
    } catch (error) {
      // console.error('Error uploading form:', error);
      // Handle upload error (show error alert or message)
      setShowErrorAlert(true);
    }

    setIsFormValidated(false);
    setIsButtonDisabled(false);

    setTimeout(() => {
      setShowSuccessAlert(false);
      setShowErrorAlert(false);
    }, 3000);
  };

  return (
    <div>
      <DashboardLayout title="Adicionar Matéria">
        <ReducedContent>
          {/* Success Alert */}
          {showSuccessAlert && (
            <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
              Matéria adicionada com sucesso!
            </Alert>
          )}

          {/* Error Alert */}
          {showErrorAlert && (
            <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
              Erro ao adicionar matéria. Verifique os campos obrigatórios.
            </Alert>
          )}

          <form
            ref={formRef}
            className={`g-3 needs-validation ${isFormValidated ? 'was-validated' : ''}`}
            noValidate
            onSubmit={handleSubmit}
          >

            <div className="input-group mb-3">
              <span className="input-group-text">Nome</span>
              <input
                className="form-control"
                aria-label="With textarea"
                name="nome"
                value={name}
                onChange={handleChange}
                required
              ></input>
              <div className="invalid-feedback">
                Forneça um nome.
              </div>
            </div>
            <div className="col-12">
              <button
                disabled={isButtonDisabled}
                className="btn btn-primary"
                type="submit"
              >
                {isButtonDisabled ? 'Processando...' : 'Adicionar'}
              </button>
            </div>
          </form>
        </ReducedContent>
      </DashboardLayout>
    </div>
  );
};

export default SubjectAdd;
